import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import '../dtp-portal.css'
import { DebuggerInstance } from '../../shared/debugger';
import Axios, { AxiosResponse } from 'axios';
import { DtpResourcesInformation } from './dtp-resources-information.component';
import { DtpResourcesGallery } from './dtp-resources-gallery.component';
import { DtpHeader } from '../dtp-header.component';
import { DtpResourcesTexts } from './dtp-resources-texts.component';

/**
 * Either visualGuid or motiveId should be set
 */
export interface IDtpResourcesParams {
    visualGuid?: string;
    motiveId?: string;
    apiKey: string;
}

export interface ITronLogoUserVisual {
    email: string;
    productName: string;
    productCode: string;
    created: Date;
    isConfirmed: boolean;
}

export interface IDtpResourcesControllerProps extends RouteComponentProps<IDtpResourcesParams> {}

interface IDtpResourcesControllerState {
    logos: IMotiveLogoInfo[];
    texts: IMotiveTextInfo[];
    data: ITronLogoUserVisual | null;
}

interface IMotiveInfo {
    logos: IMotiveLogoInfo[];
    texts: IMotiveTextInfo[];
}

export interface IMotiveLogoInfo {
    logoId: string;
    variant: string;
    customColor?: string;
}

export interface IMotiveTextInfo {
    text: string;
    font: string;
    color: string;
    isBold: boolean;
    isItalic: boolean;
}

class DtpResourcesControllerComponent extends React.PureComponent<IDtpResourcesControllerProps, IDtpResourcesControllerState>{
    private baseApiUrl: string = "";

    constructor(props: IDtpResourcesControllerProps) {
        super(props);

        this.state = {
            logos: [],
            texts: [],
            data: null
        };

        this.baseApiUrl = `/api/${this.props.match.params.apiKey}/dtp-resources/${this.props.match.params.visualGuid}`;
    }

    public componentDidMount() {
        DebuggerInstance.log('DtpResourcesControllerComponent.componentDidMount');

        Axios.get<IMotiveInfo>(this.baseApiUrl + "/motive")
            .then((val) => {
                this.setState({
                    logos: val.data.logos || [],
                    texts: val.data.texts || []
                });
            });

        Axios.get<ITronLogoUserVisual>(this.baseApiUrl + "/data")
            .then((val) => {
                this.setState({
                    data: { email: val.data.email, productCode: val.data.productCode, productName: val.data.productName, created: new Date(val.data.created), isConfirmed: val.data.isConfirmed }
                });
            });
    }

    public render() {

        return (
            <div className="dpt-portal-root">
                <DtpHeader mainTitle={"PromoTron DTP Portal"} subTitle={"Visualization information"} />
                <div className={'dtp-portal-card'}>
                    <div className="title divider">
                        <span>Visualization information</span>
                    </div>
                    <div className="content">
                        <div className="dtp-resources">
                            <div className="divider information-container">
                                <DtpResourcesInformation data={this.state.data} />
                                <div className="control-buttons-container">
                                    <a href={this.baseApiUrl + "/pdf"} download={true}>
                                        <button>Download PDF</button></a>
                                    <br />
                                    <a href={this.baseApiUrl + "/canvas"} download={true}>
                                        <button>Download Canvas</button></a>
                                    <br />
                                    <a href={this.baseApiUrl + "/visualization"} download={true}>
                                        <button>Download Visualization</button></a>
                                </div>
                            </div>
                            <div className="visual-link-container">
                                <div className="image-title-container">
                                    <div className="title">Canvas image</div>
                                    <div className="visual-image-container" role={"canvas"}>
                                        <img className="visual-preview-img" src={this.baseApiUrl + "/canvas"} />
                                    </div>
                                </div>
                                <div className="image-title-container">
                                    <div className="title">Visualization image</div>
                                    <div className="visual-image-container" role={"visualization"}>
                                        <img className="visual-preview-img" src={this.baseApiUrl + "/visualization"} />
                                    </div>
                                </div>

                            </div>
                            {this.state.logos.length > 0 &&
                                <div>
                                    <div className="title divider">
                                        <span>Original Files in Visualization</span>
                                    </div>
                                    <div className="motives-gallery-container">
                                        <DtpResourcesGallery motives={this.state.logos} apiUrl={this.baseApiUrl} />
                                    </div>
                                </div>
                            }
                            {this.state.texts.length > 0 &&
                                <div>
                                    <div className="title divider">
                                        <span>Original Texts in Visualization</span>
                                    </div>
                                    <div className="motives-gallery-container">
                                        <DtpResourcesTexts texts={this.state.texts} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const DtpResourcesController = (props: IDtpResourcesControllerProps) => <DtpResourcesControllerComponent {...props} />



// WEBPACK FOOTER //
// ./src/App/dtp-portal/dtp-resources/dtp-resources.controller.tsx